import { inquiryType, gtmEventType, contactType } from '@Components/Utilities/SandhillsConstants';
import { gtmPushEvent, truncateString } from '@Components/Utilities/SandhillsUtility';
import { useWindowSize } from '@Components/Utilities/WindowSize';
import { loadable } from '@Components/Utilities/SandhillsLoadable';
import TranslationText from '@Components/Utilities/TranslationText';
import CollapsibleContacts from '@Components/Contact/CollapsibleContacts';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { sandhillsRequest } from '@Components/Utilities/SandhillsUtility';
import { useRef } from 'react';
import translator from '@Components/Utilities/Translator';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';

const ListingDisplayLocation = loadable(() => import('@Components/Shared/Listings/ListingDisplayLocation'));
const TextMessage = loadable(() => import('@Components/Contact/TextMessage'));

const PartsListListing = (props) => {
    const windowSize = useWindowSize();
    const ref = useRef([]);
    const currentSite = useRecoilValue(atoms.currentWebsite);
    const routes = useRecoilValue(atoms.routes);
    const openEmailModal = (inquiry) => props.openEmailModal(inquiry, contactType.Retail, {
        ModalTitle: (props.Manufacturer || '') + ' Part #: ' + props.PartNumber,
        Subject: (props.Manufacturer || '') + ' Part #: ' + props.PartNumber,
        ListingID: props.PartID,
        ListingSourceDomainUrl: props.ListingSourceDomainUrl,
        PartNumber: props.PartNumber,
        Price: props.RetailPrice || '',
        Manufacturer: props.Manufacturer,
        DealerCRMID: props.DealerCRMID,
        DealerGroupID: props.DealerGroupID,
        DealerLocation: props?.DealerLocation || props?.ListingLocation?.ShortLocation || props?.ListingLocation?.FormattedLocation,
        DealerPhone: props?.FormattedRetailPhoneNumber || '',
        DealerContact: props.DealerContact || '',
        BranchName: props.DealerName || '',
        ListingURL: props.SAMURL ?? props.DetailPageURL,
        PartsSource: props.partsSource,
        IsParts: true,
        ListingCondition: props.Condition,
        Ref: ref.current[inquiry]
    });

    const getMediaIcons = () => {
        return (
            <div className='parts-image-count'>
                {props.ListingPhotoCount > 0 &&
                    <div className='parts-img-count'>
                        <LazyLoadImage visibleByDefault={'{props.ForceLoadImages}'} src={routes.CDNBaseUrl + 'Images/Icons/Miscellaneous/pictures.png'} className='listing-image-icon' width='16' height='16' alt="" />
                        <span className='listing-image-icon-text'>{props.ListingPhotoCount}</span>
                    </div>}
                {props.ListingSpin360Count > 0 &&
                    <div className='parts-img-count'>
                        <LazyLoadImage visibleByDefault={'{props.ForceLoadImages}'} src={routes.CDNBaseUrl + 'Images/Icons/Miscellaneous/pictures360.png'} className='listing-image-icon' width='16' height='16' alt="" />
                        <span className='listing-image-icon-text'>{props.ListingSpin360Count}</span>
                    </div>}
                {props.ListingVideoCount > 0 &&
                    <div className='parts-img-count'>
                        <LazyLoadImage visibleByDefault={'{props.ForceLoadImages}'} src={routes.CDNBaseUrl + 'Images/Icons/Miscellaneous/videos.png'} className='listing-image-icon' width='16' height='16' alt="" />
                        <span className='listing-image-icon-text'>{props.ListingVideoCount}</span>
                    </div>}
            </div>
        );
    };

    const saveIterableAction = (actionName) => {
        sandhillsRequest({
            url: routes.SaveAction,
            method: 'post',
            data: {
                'email': '',
                'actionName': actionName,
                'manufacturers': [props.Manufacturer],
                'categoryIDs': [props.CategoryID],
                'partIDs': [props.PartID],
                'conditions': [props.Condition]
            },
            errorHandling: {
                useConsole: false,
                useAlert: false
            }
        });
    };

    const handleBuyNowClick = () => {
        saveIterableAction('buyNow');
        gtmPushEvent(gtmEventType.buyNowClick);
    }

    const handleTelClick = () => {
        saveIterableAction('telClick');
        gtmPushEvent(gtmEventType.call);
    }

    return (windowSize.width <= 650 ?
        <div className='parts-listing-container mobile'>
            <a className='part-name-value-large bold' href={props.DetailPageURL}>{props.PartNumber}</a>
            {props.InventoryManagementURL && <a className='part-name-value' href={props.InventoryManagementURL} target='_blank'><strong>View in Inventory Management</strong> <span className='visually-hidden'>({translator.translate('sandhills.opensinanewtab')})</span></a>}
            {props.Manufacturer &&
                <div className='part-make-value bold'>
                    {props.Manufacturer}
                </div>}
            {props.ImageURL &&
                <div className='mobile-part-image-container'>
                    <a href={props.DetailPageURL}>
                        <img className='part-image' src={props.ImageURL} alt="" />
                        <span className='visually-hidden'>{translator.translate('sandhills.tradepubwebsite.mvc.viewdetailsfor') + ' ' + props.PartNumber}</span>
                    </a>
                </div>}
            {(props.ImageURL && (props.ListingPhotoCount > 0 || props.ListingVideoCount > 0 || props.ListingSpin360Count > 0)) && 
                getMediaIcons()}
            <span className='part-list-price'>
                <strong>
                {props.FormattedDiscountPrice ?
                    <span>
                        <span className='part-list-msrp'>{props.Price}</span>
                        {props.DiscountSavePercentage && <span className='list-msrp-save-percentage'>{props.DiscountSavePercentage}</span>}
                        <div><span>{props.FormattedDiscountPrice}</span></div>
                    </span>
                    : (props.ShowMSRPField && props.MSRP ?
                        <span>
                            <span className='part-list-msrp'>{props.MSRP}</span>
                            {props.MSRPSavePercentage && <span className='list-msrp-save-percentage'>{props.MSRPSavePercentage}</span>}
                            <div><span>{props.Price}</span></div>
                        </span>
                            : <span>{props.Price}</span>)}
                </strong>
            </span>
            {props.IsFreeShipping &&
                <div className='part-free-shipping'><TranslationText tKey='sandhills.freeshipping' /> <i className='fas fa-truck' /></div>}
            <div className='parts-listing-column'>
                {props.Quantity &&
                    <span className='part-name-value'>
                        <span className='bold'><TranslationText tKey='sandhills.crm.dscrm.available' />: </span>
                        {props.Quantity}
                    </span>}
                {props.Condition &&
                    <span className='part-name-value'>
                        <span className='bold'><TranslationText tKey='sandhills.condition' />: </span>
                        {props.Condition}
                    </span>}
            </div>
            <div className='mobile-parts-detail-container'>
                <div className='dealer-phone-container'>
                    <a href={'tel:' + props.UnformattedRetailPhoneNumber} onClick={handleTelClick}>
                        <i className='fas fa-phone-alt fa-flip-horizontal gtm-noclick'></i>
                        <span>{props.FormattedRetailPhoneNumber}</span>
                    </a>
                    {props.IsRetailPhoneNumberTextEnabled &&
                        <TextMessage messagePhone={props.UnformattedRetailPhoneNumber} messageBody={props.TextMessageBody} buttonText={props.FormattedRetailPhoneNumber} Id={props.PartID} ref={ref}/>}
                </div>
                <div className='dealer-name'>
                    <span className='dealer-text-large'><strong><TranslationText tKey='sandhills.seller' />:</strong></span>
                    {props.DealerWebsiteURL ?
                        <a href={props.DealerWebsiteURL} target='_blank'>
                            <span className='dealer-text-small'>{props.DealerName}</span>
                            <span className='visually-hidden'>({translator.translate('sandhills.opensinanewtab')})</span>
                        </a>
                        : <span className='dealer-text-small'>{props.DealerName}</span>}
                </div>
                <div className='dealer-location'>
                    <span className='dealer-text-large'><strong><TranslationText tKey='sandhills.location' />: </strong></span>
                    <span className='dealer-text-small'>{props.DealerLocation}</span>
                </div>
                {props.ListingLocation && <ListingDisplayLocation {...props.ListingLocation} IsMobile OneLine />}
            </div>
            {props.Description &&
                <span className='part-name-value part-description'>
                    <p>
                        {truncateString(props.Description, 200)}
                        {props.Description.length > 200 &&
                            <a className='more' href={props.DetailPageURL}><TranslationText tKey='sandhills.seemoredetails' /></a>}
                    </p>
                </span>}
            <div className='parts-listing-column'>
                <a className='view-listing-details-link des-view-listingDetails' href={props.DetailPageURL} aria-label={translator.translate('sandhills.tradepubwebsite.mvc.viewdetailsfor') + ' ' + props.PartNumber}>
                    <i className='fas fa-search-plus' aria-hidden='true' />
                    <strong><TranslationText tKey='sandhills.viewdetails' /></strong>
                </a>
                {props.BuyNowURL &&
                    <a className='buy-btn des-buy-now' href={props.BuyNowURL} onClick={handleBuyNowClick} target={(props.BuyNowNewTab || currentSite.IsMobileAppContext) ? '_blank' : '_self'}>
                        <i className='fas fa-shopping-cart' />
                        <TranslationText tKey='sandhills.buynow' />
                        {(props.BuyNowNewTab || currentSite.IsMobileAppContext) && <span className='visually-hidden'>({translator.translate('sandhills.opensinanewtab')})</span>}
                    </a>}
                <div className='contact-options contact-list'>
                    <CollapsibleContacts{...props} onOpenInquiryModal={() => openEmailModal(inquiryType.Email)} isParts ref={ref} />
                </div>
            </div>
            {props.Updated &&
                <span className='part-updated'>
                    <span className='bold'><TranslationText tKey='sandhills.updated' />: </span>
                    {props.Updated}
                </span>}
        </div> :
        <div className='parts-listing-container desktop'>
            <div className='parts-listing-column'>
                <a className='part-name-value-large bold' href={props.DetailPageURL}>{props.PartNumber}</a>
                {props.InventoryManagementURL && <a className='part-name-value' href={props.InventoryManagementURL} target='_blank'><strong>View in Inventory Management</strong> <span className='visually-hidden'>({translator.translate('sandhills.opensinanewtab')})</span></a>}
                <span className='part-list-price bold'>
                    {props.FormattedDiscountPrice ?
                        <span>
                            <span className='part-list-msrp'>{props.Price}</span>
                            {props.DiscountSavePercentage && <span className='list-msrp-save-percentage'>{props.DiscountSavePercentage}</span>}
                            <div><span>{props.FormattedDiscountPrice}</span></div>
                        </span>
                        : (props.ShowMSRPField && props.MSRP ?
                            <span>
                                <span className='part-list-msrp'>{props.MSRP}</span>
                                {props.MSRPSavePercentage && <span className='list-msrp-save-percentage'>{props.MSRPSavePercentage}</span>}
                                <div><span>{props.Price}</span></div>
                            </span>
                                : <span>{props.Price}</span>)}
                </span>
                {props.IsFreeShipping &&
                    <div className='part-free-shipping'><TranslationText tKey='sandhills.freeshipping' /> <i className='fas fa-truck' /></div>}
                {props.Manufacturer &&
                    <span className='part-make-value bold'>
                        {props.Manufacturer}
                    </span>}
                {props.Quantity &&
                    <span className='part-name-value'>
                        <span className='bold'><TranslationText tKey='sandhills.crm.dscrm.available' />: </span>
                        {props.Quantity}
                    </span>}
                {props.Condition &&
                    <span className='part-name-value'>
                        <span className='bold'><TranslationText tKey='sandhills.condition' />: </span>
                        {props.Condition}
                    </span>}
                {props.Updated &&
                    <span className='part-name-value part-updated'>
                        <span className='bold'><TranslationText tKey='sandhills.updated' />: </span>
                        {props.Updated}
                    </span>}
                {props.ListingLocation && <ListingDisplayLocation {...props.ListingLocation} OneLine />}
            </div>
            <div className='parts-listing-column'>
                {props.ImageURL &&
                    <a href={props.DetailPageURL}>
                        <img className='part-image' src={props.ImageURL} alt="" />
                        <span className='visually-hidden'>{translator.translate('sandhills.tradepubwebsite.mvc.viewdetailsfor') + ' ' + props.PartNumber}</span>
                    </a>}
                {(props.ImageURL && (props.ListingPhotoCount > 0 || props.ListingVideoCount > 0 || props.ListingSpin360Count > 0)) &&
                    getMediaIcons()}
            </div>
            <div className='parts-listing-column'>
                <span className='part-dealer-info'>
                    {props.DealerWebsiteURL ?
                        <a href={props.DealerWebsiteURL} target='_blank'><strong>{props.DealerName}</strong> <span className='visually-hidden'>({translator.translate('sandhills.opensinanewtab')})</span></a>
                        : props.DealerName}
                </span>
                <span className='part-dealer-info'>
                    {props.ShowDealerLocation && props.DealerLocation}
                </span>
                <span className='part-dealer-info'>
                    <TranslationText tKey='sandhills.phone' />: <a href={'tel:' + props.UnformattedRetailPhoneNumber} onClick={handleTelClick}>{props.FormattedRetailPhoneNumber}</a>
                </span>
                <a className='view-listing-details-link des-view-listingDetails' href={props.DetailPageURL} aria-label={translator.translate('sandhills.tradepubwebsite.mvc.viewdetailsfor') + ' ' + props.PartNumber}>
                    <i className='fas fa-search-plus' aria-hidden='true' />
                    <strong><TranslationText tKey='sandhills.viewdetails' /></strong>
                </a>
                {props.BuyNowURL &&
                    <a className='buy-btn des-buy-now' href={props.BuyNowURL} onClick={handleBuyNowClick} target={(props.BuyNowNewTab || currentSite.IsMobileAppContext) ? '_blank' : '_self'}>
                        <i className='fas fa-shopping-cart' />
                        <TranslationText tKey='sandhills.buynow' />
                        {(props.BuyNowNewTab || currentSite.IsMobileAppContext) && <span className='visually-hidden'>({translator.translate('sandhills.opensinanewtab')})</span>}
                    </a>}
                <div className='contact-options contact-list'>
                    <CollapsibleContacts {...props} onOpenInquiryModal={() => openEmailModal(inquiryType.Email)} isParts ref={ref} CustomEmailSellerTextForRetail={props.CustomEmailSellerTextForRetail} />
                </div>
            </div>
            {props.Description &&
                <span className='part-name-value part-description'>
                    <p>
                        {truncateString(props.Description, 200)}
                        {props.Description.length > 200 &&
                            <a className='more' href={props.DetailPageURL}><TranslationText tKey='sandhills.seemoredetails' /></a>}
                    </p>
                </span>}
        </div>
    );
};

export default PartsListListing;